<template lang="pug">
  v-col(cols=12 md=4)
    v-card( three-line)
      v-img( :src='entrada.imagen' height='150')
      v-card-title {{entrada.titulo}}
      v-card-text
        v-chip( x-small v-for='etiqueta, i of entrada.etiquetas' :key='i' ).mr-2 {{etiqueta}}
      v-card-text {{entrada.contenido | resumen}}
      v-card-actions
        v-col
          v-tooltip( top open-on-click :open-on-hover='false' )
            template( v-slot:activator="{ on }")
              v-icon( small color='primary' v-on='on').mr-2 fa-clock
            span {{entrada.creado_el | fecha_completa}}
          v-btn( icon :href='`/blog/${entrada.slug}`' color='primary')
            v-icon(small) fa-eye
          v-btn.my-1( small icon @click='obtener_por_id(entrada.id), $emit("_dialog", true)' color='primary')
            v-icon( small) fa-edit
          v-btn.my-1( small icon @click='eliminar(entrada.id)' :outlined='seguro_de_eliminar' color='primary')
            v-icon( small ) far fa-trash-alt
</template>
<script>
import { mapActions } from 'vuex'
  export default {
    props: {
      entrada: Object,
    },
    data: ()=>({
      seguro_de_eliminar: false,
    }),
    methods:{
      ...mapActions({
        _eliminar: 'Blog/eliminar',
        obtener_por_id: 'Blog/obtener_por_id'
      }),
      eliminar(id) {
        if (this.seguro_de_eliminar) this._eliminar(id)
        else {
          this.seguro_de_eliminar = true
          setTimeout( ()=>this.seguro_de_eliminar=false, 2500)
        }
      }
    },
   
  }
</script>